module.exports = __webpack_public_path__ + "static/media/user.ec93eda2.png";